import { render, staticRenderFns } from "./DescriptionsEditors.vue?vue&type=template&id=a76a35b4&"
import script from "./DescriptionsEditors.vue?vue&type=script&lang=js&"
export * from "./DescriptionsEditors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports